import { useCallback, useState } from 'react'

export const DRAW_TOOLS = ['highlight', 'textbox', 'line', 'arrow', 'ink', 'rect', 'ellipse']

const DEFAULT_COLOR = '#ef4444'

// Viewer-owned markup UI state. `enabled` is the on/off visibility toggle:
// off hides markups and leaves the PDF fully interactive; on shows them and
// the tool palette. Default tool is select.
export function useMarkupTools() {
  const [enabled, setEnabled] = useState(false)
  const [tool, setTool] = useState('select')
  const [color, setColor] = useState(DEFAULT_COLOR)

  const toggle = useCallback(() => {
    setEnabled((on) => {
      if (on) setTool('select')
      return !on
    })
  }, [])

  return { enabled, toggle, tool, setTool, color, setColor }
}
